import React from "react";
import { Palette, Layout, Eye, CheckCircle } from "lucide-react";
import type { GeneratedSlides } from "../types";
import { getSlideColor, getSlideBgColor } from "../utils";

interface HeaderSectionProps {
  generatedSlides: GeneratedSlides;
  slideStyle: string;
  colorScheme: string;
}

export const HeaderSection: React.FC<HeaderSectionProps> = ({
  generatedSlides,
  slideStyle,
  colorScheme,
}) => {
  const slideColor = getSlideColor(colorScheme as any);
  const bgColor = getSlideBgColor(colorScheme as any);

  return (
    <div>
      <div className="flex items-start justify-between mb-6">
        <div>
          <div
            className="inline-flex items-center gap-2 px-3 py-1 rounded-full mb-3"
            style={{ backgroundColor: bgColor }}
          >
            <CheckCircle className="w-4 h-4" style={{ color: slideColor }} />
            <span className="text-sm font-medium" style={{ color: slideColor }}>
              Apresentação Gerada com IA
            </span>
          </div>
          <h3 className="text-2xl font-bold mb-2 text-(--text-primary)">
            {generatedSlides.title}
          </h3>
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center gap-2">
              <Palette className="w-4 h-4 text-(--text-tertiary)" />
              <span className="text-sm text-(--text-tertiary)">
                {slideStyle.charAt(0).toUpperCase() + slideStyle.slice(1)} •{" "}
                {colorScheme.charAt(0).toUpperCase() + colorScheme.slice(1)}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Layout className="w-4 h-4 text-(--text-tertiary)" />
              <span className="text-sm text-(--text-tertiary)">
                {generatedSlides.slideCount} slides
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Eye className="w-4 h-4 text-(--text-tertiary)" />
              <span className="text-sm text-(--text-tertiary)">
                Público: {generatedSlides.audience}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
